import * as React from 'react';
import autobind from 'autobind-decorator';
import { observer } from 'mobx-react';
import * as moment from 'moment';
import { observable, computed } from 'mobx';
import * as uuid from 'uuid';
import { Calendar, Col, Row } from 'antd';
import { TooltipView } from 'src/core/ui/tooltip.view';
import { TextView } from 'src/core/ui/text.view';
import { DropdownView } from 'src/core/ui/dropdown.view';

interface AllotmentAvailabilityViewProps extends ComponentViewProps<number> {
	AvailabilityAllotment(allotmentId: number | null, idSupplier?: number, year?: number): Promise<AllotmentRangeDataByDay[]>;
	Occupied(allotmentId: number, date: Date): Promise<number>;
	idSuplier: number;
	suppliers: any[];
	avalabilities: AvailabilityAllotments;
	year: number;
}

@observer
export class AllotmentAvailabilityView extends React.Component<AllotmentAvailabilityViewProps, any> {
	constructor(props) {
		super(props);

		this.state = {
			selectedValueJan: null,
			selectedValueFeb: null,
			selectedValueMarch: null,
			selectedValueApril: null,
			selectedValueMay: null,
			selectedValueJune: null,
			selectedValueJuly: null,
			selectedValueAgost: null,
			selectedValueOct: null,
			selectedValueSept: null,
			selectedValueNov: null,
			selectedValueDic: null,
			selectedYear: this.props.year,
			idSupplier: this.props.idSuplier
		}
	}

	@observable
	allotmentRangeDataByDay: AllotmentRangeDataByDay[];

	@autobind
	private loadAvailabilityAllotment(allotmentId: number, idSuplier?: number, year?: number) {
		this.props.setBusy(true);
		this.props.AvailabilityAllotment(allotmentId, idSuplier, year).then(async res => {
			this.allotmentRangeDataByDay = res;
			this.setState({
				selectedValueJan: moment.utc(new Date(year, 0, 1)).startOf('day'),
				selectedValueFeb: moment.utc(new Date(year, 1, 1)).startOf('day'),
				selectedValueMarch: moment.utc(new Date(year, 2, 1)).startOf('day'),
				selectedValueApril: moment.utc(new Date(year, 3, 1)).startOf('day'),
				selectedValueMay: moment.utc(new Date(year, 4, 1)).startOf('day'),
				selectedValueJune: moment.utc(new Date(year, 5, 1)).startOf('day'),
				selectedValueJuly: moment.utc(new Date(year, 6, 1)).startOf('day'),
				selectedValueAgost: moment.utc(new Date(year, 7, 1)).startOf('day'),
				selectedValueOct: moment.utc(new Date(year, 9, 1)).startOf('day'),
				selectedValueSept: moment.utc(new Date(year, 8, 1)).startOf('day'),
				selectedValueNov: moment.utc(new Date(year, 10, 1)).startOf('day'),
				selectedValueDic: moment.utc(new Date(year, 11, 1)).startOf('day'),
				selectedYear: year,
				supplierId: idSuplier
			});
			this.props.setBusy(false);
		}).catch(error => {
			this.props.setBusy(false);
		});
	}

	componentDidMount() {
		this.loadAvailabilityAllotment(this.props.model, this.state.idSupplier, this.state.selectedYear);
	}

	componentWillReceiveProps(nextProps: Readonly<AllotmentAvailabilityViewProps>, nextContext: any) {
		if (this.props.model != nextProps.model || nextProps.idSuplier != this.props.idSuplier) {
			this.loadAvailabilityAllotment(nextProps.model, nextProps.idSuplier, nextProps.year);
		}
	}

	@autobind
	updateOccupied(ev, data: AllotmentRangeDataByDay) {
		if (data.idAllotment != null && data.idAllotment > 0) {
			//let date = moment.utc(data.date).startOf('day').toDate();
			this.props.Occupied(data.idAllotment, data.date).then(res => {
				data.occupied = res;
				this.forceUpdate();
			});
		}
			
	}

	@autobind
	getDescriptionTooltip(data: AllotmentRangeDataByDay) {
		return <ul>
			<li key={uuid.v4()}>
				{`Allocation --> ${data.limit}`}
			</li>
			<li key={uuid.v4()}>
				{`Available --> ${data.limit - data.occupied}`}
			</li>
			<li key={uuid.v4()}>
				{`Confirmed --> ${data.occupied}`}
			</li>
			<li key={uuid.v4()}>
				{`StopSale --> ${data.allotmentRangeType == 0}`}
			</li>
			<li key={uuid.v4()}>
				{`By Availability --> ${data.allotmentRangeType == 1}`}
			</li>
			<li key={uuid.v4()}>
				{`By Request --> ${data.allotmentRangeType == 2}`}
			</li>
			<li key={uuid.v4()}>
				{`Unavailable --> ${data.allotmentRangeType == 3}`}
			</li>
			<li key={uuid.v4()}>
				{`Freesell --> ${data.allotmentRangeType == 4}`}
			</li>
			<li key={uuid.v4()}>
				{`Description --> ${data.description}`}
			</li>
		</ul>;
	}

	@autobind
	protected renderDay(item: moment.Moment) {
		item = item.utc();
		let data = this.allotmentRangeDataByDay.find(x => item.isSame( x.date,"day"));
		let uid = uuid.v4();
		if (data) {

			switch (data.allotmentRangeType) {
				case 0:
					// "StopSale";
					return (<div id={uid}>
						<TooltipView title={this.getDescriptionTooltip(data)} >
							<div className='range_stopsale' onClick={(ev) => this.updateOccupied(ev, data)}>
								<Col>
									<Row>
										<Col>
											{data.description != null && data.description.length >= 2 ? data.description.substring(0, 2).concat('...') : '...'}
										</Col>
										<Col>
										</Col>
									</Row>
								</Col>
							</div>
						</TooltipView>
					</div>);
				case 1:
					// "By Availability";
					return (<div id={uid} >
						<TooltipView title={this.getDescriptionTooltip(data)}>
							<div className='range_availability' onClick={(ev) => this.updateOccupied(ev, data)} > <Col>
								<Row><Col></Col><Col></Col></Row>
								<Row><Col></Col><Col>{data.limit}</Col></Row>
							</Col>  </div>
						</TooltipView>
					</div>);
				case 2:
					// "By Request";
					return (<div id={uid}>
						<TooltipView title={this.getDescriptionTooltip(data)}>
							<div className='range_request' onClick={(ev) => this.updateOccupied(ev, data)} > <Col>
								<Row><Col></Col><Col></Col></Row>
								<Row><Col></Col><Col>{data.limit ? data.limit : data.description != null && data.description.length >= 2 ? data.description.substring(0, 2).concat('...') : '...'}</Col></Row>
							</Col>  </div>
						</TooltipView>
					</div>);
				case 3:
					// "Unavailable";
					return (<div id={uid}>
						<TooltipView title={this.getDescriptionTooltip(data)}>
							<div className='range_unavailable' onClick={(ev) => this.updateOccupied(ev, data)} >
								<Col>
									<Row>
										<Col>
											{data.description != null &&data.description.length >= 2 ? data.description.substring(0, 2).concat('...') : '...'}
										</Col>
										<Col>
										</Col>
									</Row>
								</Col>
							</div>
						</TooltipView>
					</div>);
				case 4:
					// "Freesell";
					return (<div id={uid}>
						<TooltipView title={this.getDescriptionTooltip(data)}>
							<div className='range_freesale' onClick={(ev) => this.updateOccupied(ev, data)} >
								<Col>
									<Row>
										<Col>
											{data.description!= null && data.description.length >= 2 ? data.description.substring(0, 2).concat('...') : '...'}
										</Col>
										<Col>
										</Col>
									</Row>
								</Col>
							</div>
						</TooltipView>
					</div>);

				default:
					// "UNDEFINDED";
					return (<div id={uid}>
						<TooltipView title={this.getDescriptionTooltip(data)}>
							<div className='range_gray' onClick={(ev) => this.updateOccupied(ev, data)}> {data.date.getDate()} </div>
						</TooltipView>
					</div>);
			}
		}
		return null;
	}

	private renderCalendar(month: number, selectedMonth: moment.Moment) {
		return (
			<Col xs={8} lg={8} >
				<h4 className="calendar-header">{moment.months(month)}</h4>
				<Calendar
					dateCellRender={this.renderDay}
					fullscreen={false}
					prefixCls="disable-ant-fullcalendar"
					value={selectedMonth}
				/>
			</Col>
		);
	}

	render() {
		return (this.allotmentRangeDataByDay != null && this.state.selectedValueDic) ? (<div className="card card-borderless">
			<Row>
				<Col xs={6}>
					<TextView
						label="Year"
						mode="edit"
						value={this.state.selectedYear}
						onChanged={(value) => {
							if ((value as string).length >= 4) {
								let year = value;
								let allotement = this.props.avalabilities[this.state.supplierId];
								this.loadAvailabilityAllotment(allotement.id, allotement.supplierId, year);

							}
						}}
					/>
				</Col>
				{this.props.suppliers && this.props.suppliers.length > 0 && <Col xs={6} >
					<DropdownView
						label="Supplier"
						model={this.state.supplierId}
						onChanged={(item) => {
							if (item) {
								let allotement = this.props.avalabilities[item.value.toString()];
								this.loadAvailabilityAllotment(allotement.id, item.value, this.state.selectedYear);
							}
						}}
						options={this.props.suppliers}
					/>
				</Col>}
			</Row>
			<Row>
				<Col xs={4}>
					<h4 className='legend'>
						StopSale <div className='range_stopsale'>
							{'.'}
						</div>
						By Availability <div className='range_availability'>.</div>
						By Request <div className='range_request'>.</div>
						Unavailable <div className='range_unavailable'>{'.'}</div>
						Freesell <div className='range_freesale'>{'.'}</div> </h4>
				</Col>
				<Col xs={20}>
					<Row>
						{this.renderCalendar(0, this.state.selectedValueJan)}
						{this.renderCalendar(1, this.state.selectedValueFeb)}
						{this.renderCalendar(2, this.state.selectedValueMarch)}
					</Row>
					<Row>
						{this.renderCalendar(3, this.state.selectedValueApril)}
						{this.renderCalendar(4, this.state.selectedValueMay)}
						{this.renderCalendar(5, this.state.selectedValueJune)}
					</Row>
					<Row>
						{this.renderCalendar(6, this.state.selectedValueJuly)}
						{this.renderCalendar(7, this.state.selectedValueAgost)}
						{this.renderCalendar(8, this.state.selectedValueSept)}
					</Row>
					<Row>
						{this.renderCalendar(9, this.state.selectedValueOct)}
						{this.renderCalendar(10, this.state.selectedValueNov)}
						{this.renderCalendar(11, this.state.selectedValueDic)}
					</Row>
				</Col>
			</Row>
		</div>) : (<div>

		</div>);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/allotment/form/parts/allotment-availability.view.tsx